export const featureImportanceLookup = {
  0: ['pge_excavator_clean', 'PGE Excavator Previous Digins'],
  1: ['renew_num', 'Renew Number'],
  2: ['boring_horiz', 'Horizontal Boring'],
  3: ['boring_vert', 'Vertical Boring'],
  4: ['boring_other', 'Other Boring'],
  5: ['fence', 'Fence Work Type'],
  6: ['water', 'Water Work Type'],
  7: ['sewer', 'Sewer Work Type'],
  8: ['soil', 'Soil Work Type'],
  9: ['hand_dig', 'Hand Dig Work Type'],
  10: ['electric_equip', 'Electrical Equipment Work Type'],
  11: ['priority_notNORM', 'Emergency Priority'],
  12: ['paint', 'Paint Delineation'],
  13: ['stake', 'Stake Delineation'],
  14: ['chalk', 'Chalk Delineation'],
  15: ['flag', 'Flag Delineation'],
  16: ['flour', 'Flour Delineation'],
  17: ['gdgis_distributionmain_cnt', 'GD Main'],
  18: ['gdgis_service_asset_cnt', 'GD Service'],
  19: ['gdgis_deactivatedgaspipe_cnt', 'GD Deactivated Main'],
  20: ['gtgis_centerlines_cnt', 'GT Centerline'],
  21: ['gtgis_deactivatedgaspipe_cnt', 'GT Deactivated Main'],
  22: ['edgis_secugconductor_pseudoservice_cnt', 'ED Pseudoservice'],
  23: ['edgis_secugconductor_nonpseudoservice_cnt', 'ED Non-Pseudoservice'],
  24: ['edgis_transformer_underground_cnt', 'ED Transformer'],
  25: ['edgis_streetlight_cnt', 'ED Streetlight'],
  26: ['edgis_vaultpoly_cnt', 'ED Vault Polygon'],
  27: ['edgis_dcconductor_cnt', 'ED DC Conductor'],
  28: ['edgis_priugconductor_cnt', 'ED Primary Underground Conductor'],
  29: ['tcgis_fiberopticcable_cnt', 'Fiber'],
  30: ['gdgis_distributionmain_len_plastic', 'GD Main Length Plastic (ft)'],
  31: ['gdgis_service_len_plastic', 'GD Service Plastic Length (ft)'],
};
